// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._12ji1r31{outline-color:currentColor}\n._12y31o36{outline-width:medium}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1qu2glyw{outline-style:none}\n._2lx21bp4{flex-direction:column}\n._4t3i1osq{height:100%}\n._kqswh2mm{position:relative}\n._kqswstnw{position:absolute}", ""]);
// Exports
module.exports = exports;
